<template>
    <div>
        <el-dialog title="公用字段   (勾选为不可见字段)" :visible.sync="show" width="600px" :modal-append-to-body='true' :append-to-body="true">
            <div class="pd">
                <el-table :data="tableData" border ref="filedTable" style="width: 100%" height="450" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="40">
                    </el-table-column>
                    <el-table-column prop="chineseField" label="显示名称">
                    </el-table-column>
                    <el-table-column prop="entityField" label="英文名称">
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="selField">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: "invisibleField",
        components: {},
        data() {
            return {
                tableData: [],
                show: false,
                multipleSelection: []
            };
        },

        props: {},
        watch: {},
        computed: {},
        mounted() {},
        created() {},
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 打开方案弹窗
            openDia(id) {
                this.opmId = id
                this.getInvisibleDictList(id)
                this.show = true
            },
            // 获取所有不可见属性字典表
            async getInvisibleDictList() {
                let responseData = await this.$http.invisibleDictList()
                if (responseData.status == 200) {
                    this.tableData = responseData.result
                    this.getInvisibleOpminvisible()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            },
            // 确定选择
            async selField() {
                this.multipleSelection.forEach(item=>{
                    item.opmId = this.opmId
                })
                let params = JSON.parse(JSON.stringify(this.multipleSelection))
                let responseData = await this.$http.invisibleSaveOpminvisible(params)
                if (responseData.status == 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.show = false
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            },
            // 获取人员不可见属性
            async getInvisibleOpminvisible() {
                let responseData = await this.$http.invisibleOpminvisible({
                    ids: [this.opmId]
                })
                if (responseData.status == 200) {
                    this.selList = responseData.result
                    this.tableData.forEach(item => {
                        this.selList.forEach(key=>{
                            if (item.deId == key.deId) this.$refs.filedTable.toggleRowSelection(item)
                        })
                    });
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            },
        },
    };
</script>
<style scoped>
    .el-pagination {
        padding: 20px 0px 5px;
    }

    .pd {
        padding-bottom: 20px;
    }
</style>